export default {
    getOptions(items, labelKey, valueKey) {
        let labelKeys = []

        if (Array.isArray(labelKey)) {
            labelKeys = labelKey
        } else {
            labelKeys = [labelKey]
        }

        let options = []
        for(let item in items) {
            item = items[item]

            let labels = []
            for(let labelKey in labelKeys) {
                labelKey = labelKeys[labelKey]
                labels.push(item[labelKey])
            }
            options.push({
                label: labels.join(' '),
                value: item[valueKey]
            })
        }
        return options
    },
    label(value, options) {
        if (Array.isArray(value)) {
            let values = value
            let labels = []
            for (value in values) {
                value = values[value]
                for (let option in options) {
                    option = options[option]
                    if (option.value.toString() === value.toString()) {
                        labels.push(option.label)
                    }
                }
            }
            return labels.join(', ')
        } else {
            if (value !== undefined) {
                if (value.label !== undefined) {
                    return value.label
                } else {
                    for (let option in options) {
                        option = options[option]
                        if (option.value.toString() === value.toString()) {
                            return option.label
                        }
                    }
                }
            }
        }
        return ''
    },
    value(value) {
        if (value !== undefined && value !== null) {
            if (value.value === undefined) {
                return value
            }
            return value.value
        }
        return null
    },
    isEmpty(value) {
        if (value !== undefined && value !== null) {
            if (value.value !== undefined) {
                return false
            }
        }
        return true
    },
    select(value, options) {
        for (let option in options) {
            option = options[option]
            if (option.value === value) {
                return option
            }
        }
        return null
    }
}
